module.exports = __webpack_public_path__ + "static/media/mobile.68309de1.svg";